import evolve from 'ramda/es/evolve';
import omit from 'ramda/es/omit';
import assoc from 'ramda/es/assoc';

import {
  STUDENT_STATUSES_FILTER_CLEAR,
  STUDENT_STATUSES_FILTER_DELETE,
  STUDENT_STATUSES_FILTER_SET,
  STUDENT_STATUSES_FILTER_UPDATE,
} from 'app/actions/reports/filters/studentStatuses';

import * as statuses from 'app/common/constants/students/statuses';


const defaultState = {
  data: {
    [statuses.ACTIVE]: {
      id: statuses.ACTIVE,
      title: 'Текущие',
    },
    [statuses.EXPELLED]: {
      id: statuses.EXPELLED,
      title: 'Выбывшие',
    },
    [statuses.GRADUATED]: {
      id: statuses.GRADUATED,
      title: 'Выпускники',
    },
    // не должно быть в "Остаток средств"
    // [statuses.PENDING]: {
    //   id: statuses.PENDING,
    //   title: 'Ожидающие приема',
    // },
  },
  selected: {},
  active: false,
};

const studentStatuses = (state = defaultState, { type, payload }) => {
  switch (type) {
    case STUDENT_STATUSES_FILTER_CLEAR: {
      return defaultState;
    }
    case STUDENT_STATUSES_FILTER_DELETE: {
      return evolve({ selected: omit(payload) }, state);
    }
    case STUDENT_STATUSES_FILTER_SET: {
      return assoc('selected', payload, state);
    }
    case STUDENT_STATUSES_FILTER_UPDATE: {
      return { ...state, ...payload };
    }
    default:
  }
  return state;
};

export default studentStatuses;
